module.exports = __webpack_public_path__ + "img/bg3.f97c2c07.png";